import {
  baseVendorApiSettingsDefaults,
  defaultHttpAgentSettings,
  defaultRateLimitationSettings,
  defaultSessionSettings,
  defaultVendorApiHttpAdvancedSettings,
} from './base';
import type { HttpBasedSessionVendorApiSettingsDefaults } from './types';

export const forcePointDefaults: HttpBasedSessionVendorApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultHttpAgentSettings,
  ...defaultRateLimitationSettings,
  ...defaultSessionSettings,
  ...defaultVendorApiHttpAdvancedSettings,
  maxConcurrentRequests: 10,
  maxAttemptsOnRecoverableNetworkError: 8,
  defaultSessionTimeoutSec: 0,
};
